module.exports = require("@swa-ui/core/src/CollapsibleCard/CollapsibleCard.module.scss");